import React, { useRef } from 'react';
import cn from 'classnames';
import style from './lines.mod.scss';
import Lead from '../lead/lead';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Lines = ({ heading }) => {
  const classes = cn(style.lines);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.6,
    rootMargin: '-40px',
  });

  return (
    <div className={classes}>
      <Lead heading={heading} headingTag={1} headingColor={'red'} />
      <div className={style.lines__main} ref={ref}>
        <MainSVG inView={inView} />
      </div>
    </div>
  );
};

export default Lines;

const MainSVG = ({ inView }) => {
  const leftVariants = {
    hidden: { opacity: 0, x: -250 },
    visible: { opacity: 1, x: 0 },
  };

  const rightVariants = {
    hidden: { opacity: 0, x: 350 },
    visible: { opacity: 1, x: 0 },
  };

  const leftTransition = {
    duration: 1,
    delay: 0.3,
  };

  const rightTransition = {
    duration: 0.75,
    delay: 0.75,
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 2500 844">
      <motion.g
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={leftVariants}
        transition={leftTransition}
      >
        <path
          fill="#007D48"
          d="M303.78 32.468h-16.414c-2.151 3.512-4.389 6.935-6.671 10.358-8.734-7.856-20.584-12.2-33.224-11.016a43.427 43.427 0 00-27.782 13.694 42.54 42.54 0 00-15.712-1.405c-23.919 2.239-41.475 23.481-39.237 47.4a44.473 44.473 0 001.449 7.725c-9.568 8.91-15.054 21.989-13.738 35.99.922 9.568 4.828 18.126 10.753 24.797-3.335 2.282-6.715 4.565-10.138 6.759v124.163h151.68-.878c59.47 0 107.704-48.234 107.704-107.704v-43.1c0-59.47-48.234-107.704-107.704-107.704l-.088.044zm43.099 166.956c0 11.894-9.655 21.549-21.549 21.549s-21.55-9.655-21.55-21.549v-13.913h43.099v13.913z"
        ></path>
        <path
          stroke="#007D48"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="61.445"
          d="M303.78 32.468h-16.414c-2.151 3.512-4.389 6.935-6.671 10.358-8.734-7.856-20.584-12.2-33.224-11.016a43.427 43.427 0 00-27.782 13.694 42.54 42.54 0 00-15.712-1.405c-23.919 2.239-41.475 23.481-39.237 47.4a44.473 44.473 0 001.449 7.725c-9.568 8.91-15.054 21.989-13.738 35.99.922 9.568 4.828 18.126 10.753 24.797-3.335 2.282-6.715 4.565-10.138 6.759v124.163h151.68-.878c59.47 0 107.704-48.234 107.704-107.704v-43.1c0-59.47-48.234-107.704-107.704-107.704l-.088.044zm43.099 166.956c0 11.894-9.655 21.549-21.549 21.549s-21.55-9.655-21.55-21.549v-13.913h43.099v13.913z"
        ></path>
        <path
          fill="#fff"
          d="M411.563 183.23v-43.1c0-59.47-48.234-107.704-107.703-107.704h-16.415c-32.916 52.93-77.902 97.566-134.343 134.345v124.163h151.68-.878c59.469 0 107.703-48.234 107.703-107.704h-.044zm-150.802 16.151c0 11.894-9.656 21.55-21.549 21.55-11.894 0-21.55-9.656-21.55-21.55v-43.099c0-11.894 9.656-21.55 21.55-21.55 11.893 0 21.549 9.656 21.549 21.55v43.099zm86.154 0c0 11.894-9.656 21.55-21.55 21.55-11.893 0-21.549-9.656-21.549-21.55v-13.913h43.099v13.913z"
        ></path>
        <path
          fill="#004E1B"
          d="M163.16 160.011c48.103-32.917 87.427-71.89 117.535-117.185-8.734-7.856-20.584-12.2-33.224-11.016a43.43 43.43 0 00-27.782 13.694 42.54 42.54 0 00-15.712-1.405c-23.919 2.239-41.475 23.481-39.237 47.4a44.473 44.473 0 001.449 7.725c-9.568 8.91-15.054 21.989-13.738 35.99.922 9.568 4.828 18.126 10.753 24.797h-.044z"
        ></path>
      </motion.g>
      <motion.g
        clipPath="url(#clip0_4_3)"
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={rightVariants}
        transition={rightTransition}
      >
        <path
          fill="#4B83B6"
          d="M2115.89 311.725h-35.38c-48.82 0-88.42 39.6-88.42 88.424v123.808h123.8c48.83 0 88.43-39.6 88.43-88.424v-35.384c0-48.824-39.6-88.424-88.43-88.424zm17.69 154.76c-9.76 0-17.69-7.927-17.69-17.692v-17.692c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v17.692c0 2.45-.51 4.756-1.41 6.882-2.7 6.342-8.97 10.81-16.29 10.81zm-70.73 0c-9.76 0-17.69-7.927-17.69-17.692v-35.384c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v35.384c0 9.765-7.93 17.692-17.7 17.692zm-97.71-111.415h-39.13v39.132c0 14.413 11.67 26.088 26.09 26.088h13.04c14.41 0 26.09-11.675 26.09-26.088v-13.044c0-14.413-11.68-26.088-26.09-26.088z"
        ></path>
        <path
          fill="#fff"
          d="M2115.89 311.725h-35.38c-48.82 0-88.42 39.6-88.42 88.424v123.808h123.8c48.83 0 88.43-39.6 88.43-88.424v-35.384c0-48.824-39.6-88.424-88.43-88.424zm17.69 154.76c-9.76 0-17.69-7.927-17.69-17.692v-17.692c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v17.692c0 2.45-.51 4.756-1.41 6.882-2.7 6.342-8.97 10.81-16.29 10.81zm-70.73 0c-9.76 0-17.69-7.927-17.69-17.692v-35.384c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v35.384c0 9.765-7.93 17.692-17.7 17.692zm-97.71-111.415h-39.13v39.132c0 14.413 11.67 26.088 26.09 26.088h13.04c14.41 0 26.09-11.675 26.09-26.088v-13.044c0-14.413-11.68-26.088-26.09-26.088z"
        ></path>
        <path
          stroke="#4B83B6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="50.446"
          d="M2115.89 311.725h-35.38c-48.82 0-88.42 39.6-88.42 88.424v123.808h123.8c48.83 0 88.43-39.6 88.43-88.424v-35.384c0-48.824-39.6-88.424-88.43-88.424zm17.69 154.76c-9.76 0-17.69-7.927-17.69-17.692v-17.692c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v17.692c0 2.45-.51 4.756-1.41 6.882-2.7 6.342-8.97 10.81-16.29 10.81zm-70.73 0c-9.76 0-17.69-7.927-17.69-17.692v-35.384c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v35.384c0 9.765-7.93 17.692-17.7 17.692zm-97.71-111.415h-39.13v39.132c0 14.413 11.67 26.088 26.09 26.088h13.04c14.41 0 26.09-11.675 26.09-26.088v-13.044c0-14.413-11.68-26.088-26.09-26.088z"
        ></path>
        <path
          fill="#1D2A6E"
          d="M2151.27 448.793c0 9.765-7.93 17.692-17.69 17.692-9.76 0-17.69-7.927-17.69-17.692v-17.692c0-9.765 7.93-17.692 17.69-17.692 9.76 0 17.69 7.927 17.69 17.692v17.692zm-70.73 0c0 9.765-7.93 17.692-17.69 17.692-9.77 0-17.69-7.927-17.69-17.692v-35.384c0-9.765 7.92-17.692 17.69-17.692 9.76 0 17.69 7.927 17.69 17.692v35.384zm123.81-48.644c0-48.824-39.6-88.424-88.43-88.424h-35.38c-48.82 0-88.42 39.6-88.42 88.424v123.808h123.8c48.83 0 88.43-39.6 88.43-88.424v-35.384zm-239.22 20.21h-13.04c-14.42 0-26.09-11.675-26.09-26.088v-39.167h39.13c14.41 0 26.09 11.674 26.09 26.087v13.044c0 14.413-11.68 26.088-26.09 26.088v.036z"
        ></path>
        <path
          fill="#fff"
          d="M2182.64 431.781c0-26.376-21.41-47.779-47.78-47.779h-73.18c-26.38 0-47.78 21.403-47.78 47.779 0 26.376 21.4 47.78 47.78 47.78h73.18c26.37 0 47.78-21.404 47.78-47.78zm-102.05 17.008c0 9.765-7.92 17.692-17.69 17.692-9.76 0-17.69-7.927-17.69-17.692v-35.384c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.69 7.927 17.69 17.692v35.384zm70.74 0c0 9.765-7.93 17.692-17.7 17.692-9.76 0-17.69-7.927-17.69-17.692v-17.692c0-9.765 7.93-17.692 17.69-17.692 9.77 0 17.7 7.927 17.7 17.692v17.692z"
        ></path>
      </motion.g>
      <path
        fill="#43D49D"
        d="M1281 289c88.37 0 160 71.634 160 160s-71.63 160-160 160H0V289h1281z"
      ></path>
      <path
        fill="#204D72"
        d="M2500 524v320H1219c-88.37 0-160-71.634-160-160s71.63-160 160-160h1281z"
      ></path>
      <path
        fill="#FF4C47"
        d="M1245.85 609H1077s18.06-40.363 57.51-65.279c39.45-24.916 111.34-20.402 111.34-20.402H1423s-20.01 32.772-65.88 59.227C1311.25 609 1245.85 609 1245.85 609z"
      ></path>
      <defs>
        <clipPath id="clip0_4_3">
          <path fill="#fff" d="M1900 286h330v264h-330z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
